import ShareTitleList from 'modules/partners/pages/ShareTitleList';
import { ShareTitleListPageProvider } from 'modules/partners/pages/ShareTitleList/context/ShareTitleListPageContext';

const ShareTitleListPage = () => (
  <ShareTitleListPageProvider>
    <ShareTitleList />
  </ShareTitleListPageProvider>
);

export default ShareTitleListPage;
